import React from 'react';

interface PaginationInfo {
  currentPage: number;
  totalPages: number;
  totalItems?: number;
  hasNext: boolean;
  hasPrev: boolean;
}

interface PaginationProps {
  pagination: PaginationInfo;
  onPageChange: (page: number) => void;
  itemName?: string; // es. "utenti", "segnalazioni"
  showItemCount?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({ 
  pagination, 
  onPageChange, 
  itemName = 'elementi',
  showItemCount = true 
}) => {
  const { currentPage, totalPages, totalItems, hasNext, hasPrev } = pagination;

  if (totalPages <= 1) {
    return null;
  }

  const handlePrevious = () => {
    if (hasPrev) {
      onPageChange(Math.max(currentPage - 1, 1));
    }
  };

  const handleNext = () => {
    if (hasNext) {
      onPageChange(Math.min(currentPage + 1, totalPages));
    }
  };

  return (
    <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200">
      {/* Mobile version */}
      <div className="flex-1 flex justify-between sm:hidden">
        <button
          onClick={handlePrevious}
          disabled={!hasPrev}
          className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Precedente
        </button>
        <button
          onClick={handleNext}
          disabled={!hasNext}
          className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Successiva
        </button>
      </div>

      {/* Desktop version */}
      <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
        <div>
          {showItemCount && totalItems !== undefined ? (
            <p className="text-sm text-gray-700">
              Pagina <span className="font-medium">{currentPage}</span> di{' '}
              <span className="font-medium">{totalPages}</span> ({totalItems} {itemName} totali)
            </p>
          ) : (
            <p className="text-sm text-gray-700">
              Pagina <span className="font-medium">{currentPage}</span> di{' '}
              <span className="font-medium">{totalPages}</span>
            </p>
          )}
        </div>
        
        <div>
          <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px">
            <button
              onClick={handlePrevious}
              disabled={!hasPrev}
              className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              ←
            </button>
            <button
              onClick={handleNext}
              disabled={!hasNext}
              className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              →
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Pagination;